export { default } from './ProfilerDoc'